export enum AgoraMediaType {
    Audio = 'audio',
    Video = 'video'
}